import { Output } from '@angular/core';
import { Component, OnInit, Input, EventEmitter } from '@angular/core';

@Component({
  selector: 'siu-data-grid-buttons-editable',
  templateUrl: './data-grid-buttons-editable.component.html',
  styleUrls: [ './data-grid-buttons-editable.component.scss' ]
})
export class DataGridButtonsEditableComponent implements OnInit {

  @Input() disabled: boolean = false;
  @Output('on-save') onSaveEvent: EventEmitter<any> = new EventEmitter();
  @Output('on-cancel') onCancelEvent: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  handleClickSave = () => {
    this.onSaveEvent.emit();
  }

  handleClickCancel = () => {
    this.onCancelEvent.emit();
  }

}
